import { addDataToLocalStorageByPrefix, getDataFromLocalStorageByPrefix } from '@/composables/localStorageHelper'
import appConstants from '@/constants/constants'
import { computed, ref } from 'vue'
import store from '@/store'
import useAuth from '@/composables/auth'
import useApp from '@/composables/app'

const userLastRequestCheckerInterval = ref(null)

export default function useWindow() {
  const canUseUserOnlineChecker = computed(() => store.getters['auth/canUseUserOnlineChecker'])
  const { logout } = useAuth()
  const { getCurrentTime } = useApp()

  const setResizeTimer = method => {
    let resizeTimer
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => method(), 150)
    })
  }
  const removeResizeTimer = method => window.removeEventListener('resize', method)
  const refreshLastActionTime = () => {
    addDataToLocalStorageByPrefix(appConstants.user.sessionState.LAST_ACTION_LOCAL_STORAGE_KEY, getCurrentTime())
  }
  const initUserOnlineCheckerListeners = () => {
    window.addEventListener('click', refreshLastActionTime)
    window.addEventListener('keydown', refreshLastActionTime)
    window.addEventListener('mousemove', refreshLastActionTime)
  }
  const clearUserOnlineChecker = () => {
    window.removeEventListener('click', refreshLastActionTime)
    window.removeEventListener('keydown', refreshLastActionTime)
    window.removeEventListener('mousemove', refreshLastActionTime)
    clearInterval(userLastRequestCheckerInterval.value)
    userLastRequestCheckerInterval.value = null
  }
  const setUserOnlineChecker = () => {
    initUserOnlineCheckerListeners()
    refreshLastActionTime()
    userLastRequestCheckerInterval.value = setInterval(() => {
      const lActTm = getDataFromLocalStorageByPrefix(appConstants.user.sessionState.LAST_ACTION_LOCAL_STORAGE_KEY)
      const ctm = getCurrentTime()
      const maxDiff = 3540000
      if (ctm - lActTm > maxDiff) {
        logout(appConstants.auth.logoutReason.INACTIVE_SESSION)
      }
    }, 60000)
  }
  const prohibitUseUserOnlineChecker = () => store.commit('auth/SET_CAN_USE_USER_ONLINE_CHECKER', false)
  const allowUseUserOnlineChecker = () => store.commit('auth/SET_CAN_USE_USER_ONLINE_CHECKER', true)

  return {
    canUseUserOnlineChecker,

    setResizeTimer,
    removeResizeTimer,
    setUserOnlineChecker,
    clearUserOnlineChecker,
    prohibitUseUserOnlineChecker,
    allowUseUserOnlineChecker,
    refreshLastActionTime,
  }
}